<template>
  <section class="cd-container" id="cd-timeline">
    <!-- <b-button @click="test()">check</b-button> -->
    <span v-if="contentHistory.length <= 0">No History</span>
    <div
      v-else
      class="cd-timeline-block"
      v-for="(item, i) in contentHistory"
      :key="i"
      @click="scrollTo(`element${i}`)"
    >
      <div
        class="cd-timeline-img cd-picture"
        :style="
          i % 3 == 0 ? 'background-color: #e2f2fe ' : 'background-color:#E9D2DA'
        "
      >
        <!-- <feather type="mail" style="width: 1.5rem; height: 1.5rem"></feather> -->
        <i
          class="fa fa-envelope-o"
          :class="i % 3 == 0 ? 'text-primary' : 'text-danger'"
          style="font-size: 1.2rem"
        ></i>
      </div>
      <div class="cd-timeline-content">
        <p class="m-0">{{ item.from }}</p>
        <!-- <p class="m-0 text-muted">
          {{ new Date() | moment('ddd DD/MM/YYYY HH.mm') }}
        </p> -->
        <!-- <span class="cd-date">Jan <span class="counter digits"> 14</span></span> -->
      </div>
    </div>
  </section>
</template>

<script>
  // import VueScrollTo from 'vue-scrollto'
  // Vue.use(VueScrollTo)
  export default {
    data() {
      return {
        contentHistory: [],
      };
    },
    mounted() {
      const self = this;
      this.$root.$on('setContentHistory', (data) => {
        self.setContentHistory(data);
        self.$emit('openHistory', true);
      });
    },
    beforeDestroy(){
        this.$root.$off('setContentHistory', null)
    },
    methods: {
      scrollTo(id) {
        this.$emit('scrollTo', id);
      },
      setContentHistory(data) {
        this.contentHistory = data;
      },
    },
  };
</script>

<style></style>
